export default __webpack_public_path__ + "static/media/outlook_logo.87f65f2c.svg";